import React, { useState, useEffect } from "react";
import Header from "./Header";
import Loader from "./Loader.js";
import "./Css/Addevent.css";
import removebtn from "../assets/newDelet.svg";
import {
  APL_LINK,
  server_post_data,
  det_category_image_dashboard,
  delete_image_data,
  det_category_image,
} from "../ServiceConnection/serviceconnection.js";
import { handleError, handleSuccess } from "../CommonJquery/CommonJquery";

function AddEvent() {
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [imgLink, setimgLink] = useState("");
  const [esgArr, setEsgArr] = useState(Array(5).fill(null));
  const [Renewable, setRenewable] = useState(Array(5).fill(null));
  const [Energyman, setEnergy] = useState(Array(5).fill(null));
  const [EHS, setEHS] = useState(Array(5).fill(null));
  const [ESIA, setESIA] = useState(Array(5).fill(null));
  const [EnergyTrans, setEnergyTrans] = useState(Array(5).fill(null));
  const [objectUrls, setObjectUrls] = useState([]);

  useEffect(() => {
    return () => {
      objectUrls.forEach((url) => {
        if (url && !url.startsWith("http")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [objectUrls]);

  const getStateHandler = (category) => {
    switch (category) {
      case "esgArr":
        return [esgArr, setEsgArr];
      case "Renewable":
        return [Renewable, setRenewable];
      case "Energyman":
        return [Energyman, setEnergy];
      case "EHS":
        return [EHS, setEHS];
      case "ESIA":
        return [ESIA, setESIA];
      case "EnergyTrans":
        return [EnergyTrans, setEnergyTrans];
      default:
        return [null, null];
    }
  };

  const handleFileUpload = (e, category, index) => {
    if (!e.target.files || !e.target.files[0]) return;

    const file = e.target.files[0];
    const [state, setState] = getStateHandler(category);

    if (!state || !setState) return;

    // Create URL for preview
    const previewUrl = URL.createObjectURL(file);
    setObjectUrls((prev) => [...prev, previewUrl]);

    setState((prev) => {
      const newArr = [...prev];
      // If there was a previous object URL, revoke it
      if (newArr[index]?.preview && !newArr[index]?.isUrl) {
        URL.revokeObjectURL(newArr[index].preview);
        setObjectUrls((prev) =>
          prev.filter((url) => url !== newArr[index].preview)
        );
      }
      newArr[index] = {
        file,
        preview: previewUrl,
        isUrl: false,
        isNew: true, // Flag to indicate this is a new upload
      };
      return newArr;
    });
  };

  const removeImage = (category, index , img) => {
    master_data_action_update(img);
    const [state, setState] = getStateHandler(category);
    if (!state || !setState) return;

    setState((prev) => {
      const newArr = [...prev];
      if (newArr[index]?.preview && !newArr[index]?.isUrl) {
        URL.revokeObjectURL(newArr[index].preview);
        setObjectUrls((prev) =>
          prev.filter((url) => url !== newArr[index].preview)
        );
      }
      newArr[index] = null;
      return newArr;
    });
  };

  const saveCategoryImages = async (categoryName, images) => {
    setshowLoaderAdmin(true);
    const files = images.filter((item) => item?.file).map((item) => item.file);

    if (files.length === 0) {
      alert("No images selected for upload.");
      setshowLoaderAdmin(false);
      return;
    }

    const fd = new FormData();
    fd.append("category_name", categoryName);
    fd.append("flag", "1");

    files.forEach((file, index) => {
      fd.append(`doctor_image_new_${index}`, file);
    });

    try {
      const response = await server_post_data(det_category_image_dashboard, fd);
      setshowLoaderAdmin(false);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        alert(`${categoryName} images have been saved successfully!`);
        master_data_get(); // Refresh data after save
      }
    } catch (error) {
      setshowLoaderAdmin(false);
      handleError("network");
    }
  };

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("flag", "1");

    try {
      const response = await server_post_data(det_category_image, fd);

      if (response.data.error) {
        handleError(response.data.message);
      } else {
        const allImages = response.data.message.image;

        const processImages = (categoryName, setState) => {
          const images = allImages.filter(
            (item) => item.category_name === categoryName
          );
          const processedImages = Array(5).fill(null);

          images.forEach((item, index) => {
            if (index < 5) {
              processedImages[index] = {
                preview: item.category_image,
                isUrl: true,
              };
            }
          });

          setState(processedImages);
        };

        setimgLink(response.data.message.image_link);

        // Update each category
        processImages("esgArr", setEsgArr);
        processImages("Renewable", setRenewable);
        processImages("Energyman", setEnergy);
        processImages("EHS", setEHS);
        processImages("ESIA", setESIA);
        processImages("EnergyTrans", setEnergyTrans);
      }
    } catch (error) {
      handleError("network");
    } finally {
      setshowLoaderAdmin(false);
    }
  };

  useEffect(() => {
    master_data_get();
  }, []);


  const master_data_action_update = async (img) => {
    setshowLoaderAdmin(true);
    const fd = new FormData();
    fd.append("id_for_delete", img);
    await server_post_data(delete_image_data, fd)
      .then((Response) => {
        setshowLoaderAdmin(false);
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          handleSuccess(Response.data.message);
          master_data_get();
        }
      })
      .catch((error) => {
        console.log(error);
        handleError("network");
        setshowLoaderAdmin(false);
      });
  };




  const renderCategory = (title, category, stateArray) => (
    <div className="category">
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        <div style={{ minWidth: "300px" }}>
          <h5>{title}</h5>
          <p>{stateArray.filter(Boolean).length}/5 images uploaded</p>
        </div>
        <div className="upload-boxes">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="upload-box">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleFileUpload(e, category, index)}
              />
              {!stateArray[index] && (
                <p className="upload-placeholder">Upload Image</p>
              )}
          
              {stateArray[index] && (
                <div className="image-container">
                  <img
                    src={
                      stateArray[index].isUrl
                        ? `${APL_LINK}${imgLink}${stateArray[index].preview}`
                        : stateArray[index].preview
                    }
                    alt={`${title}-img-${index + 1}`}
                    className="image-preview"
                  />
                  {console.log(stateArray[index].preview)}
                  <button
                    className="remove-btn"
                    onClick={() => removeImage(category, index , stateArray[index].preview)}
                  >
                    <img src={removebtn} alt="Remove" />
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
        <button className="btnSave"
          style={{
            width: "fit-content",
            padding: "0 1rem",
            border: "none",
            borderRadius: "8px",
            color: "white",
          }} onClick={() => saveCategoryImages(category, stateArray)}>
          Save
        </button>
      </div>
    </div>
  );

  return (
    <div className="dashboard">
      {showLoaderAdmin && <Loader />}
      <div className="dashboard_container">
        <div className="page_content">
          <div className="page_content_container">
            <Header />
            <div className="mt-4 mb-2 event_container">
              <h3>Add Event</h3>
              {renderCategory("ESG Consultants", "esgArr", esgArr)}
              {renderCategory("Renewable Energy", "Renewable", Renewable)}
              {renderCategory("Energy Management", "Energyman", Energyman)}
              {renderCategory("EHS", "EHS", EHS)}
              {renderCategory("ESIA", "ESIA", ESIA)}
              {renderCategory("Energy Transition", "EnergyTrans", EnergyTrans)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddEvent;
